import React, { useEffect } from "react";
import eventImg1 from "../../assets/images/campaign3.jpeg";
import eventImg5 from "../../assets/images/event-5.jpg";
import eventImg from "../../assets/images/event.jpeg";
import eventImg2 from "../../assets/images/latest-5.jpg";
import eventImg6 from "../../assets/images/latest-6.jpg";
import eventImg4 from "../../assets/images/slider.jpeg";
import LatestNews from "../../components/letestNews/LatestNews";

const EventPage = () => {
  const data = [
    {
      id: 1,
      img: eventImg1,
      title:
        "Empowering Global Education: 100 Scholarships for Studying in China",
      date: "08:00AM, October 15, 2022 ",
      content:
        "In 2025, Malisha Foundation will provide scholarships to 100 deserving students from various countries, enabling them to pursue higher education in China. This initiative aims to bridge educational gaps, empower students with global opportunities, and foster international collaboration. We believe that education is the key to unlocking potential, and these scholarships will ensure students have the resources to build a brighter future",
      location: "4102 Lynn Avenue, Hudson, United States",
      link: "#",
    },
    {
      id: 2,
      img: eventImg2,
      title:
        "Supporting 50 Primary and Secondary Level Students with Tuition Fees ",
      date: "08:00AM, October 15, 2022 ",
      content:
        "Malisha Foundation is committed to supporting the education of young minds. In 2025, we will assist 50 students by covering their tuition fees for primary and secondary education. This initiative targets underprivileged communities, ensuring that financial constraints do not hinder a child’s access to quality education. Our goal is to create a level playing field for all students, helping them thrive academically without the burden of school fees.",
      location: "4102 Lynn Avenue, Hudson, United States",
      link: "#",
    },
    {
      id: 3,
      img: eventImg,
      title: "Establishing 5 Chinese Corner Libraries for Cultural Exchange",
      date: "08:00AM, October 15, 2022 ",
      content:
        "To promote the Chinese language and culture, Malisha Foundation will establish 5 Chinese Corner libraries in 2025. These libraries will serve as a hub for students to explore Chinese literature, language, and history. We aim to encourage cultural exchange and provide resources for students to learn more about China’s rich heritage. The Chinese Corner libraries will foster global understanding and enhance language skills among students worldwide.",
      link: "#",
    },
    {
      id: 4,
      img: eventImg4,
      title: "Providing Study Materials to Needy Students",
      date: "08:00AM, October 15, 2022 ",
      content:
        "In 2025, Malisha Foundation will assist underprivileged students by providing essential study materials, including books, stationery, and other educational resources. This initiative ensures that students from underprivileged backgrounds can fully participate in their education without the financial burden of purchasing supplies. Our mission is to create an equitable learning environment where every student has the tools they need to succeed academically and reach their potential.",
      link: "#",
    },
    {
      id: 5,
      img: eventImg5,
      title: "Free Education for Street Children",
      date: "08:00AM, October 15, 2022 ",
      content:
        "Malisha Foundation is dedicated to providing free education to street children, ensuring that every child, regardless of their circumstances, has access to quality learning. Our program focuses on offering basic education, life skills, and a safe environment for children living on the streets. By removing financial barriers and providing essential resources, we aim to empower these children with the knowledge and skills needed to break the cycle of poverty and build a better future",
      link: "#",
    },
    {
      id: 6,
      img: eventImg6,
      title: "Aid for Underprivileged Communities",
      date: "08:00AM, October 15, 2022 ",
      content:
        "Malisha Foundation is dedicated to providing support to underprivileged communities through a range of initiatives aimed at improving living conditions and promoting equal opportunities. Our programs focus on providing essential resources such as food, healthcare, education, and financial assistance to families and individuals in need. By addressing the root causes of poverty and inequality, we aim to empower these communities, helping them build a sustainable and brighter future for generations to come",
      link: "#",
    },
  ];

  const breadCrumbArray = [
    {
      id: 1,
      title: "Home",
      link: "/",
      active: false,
    },
    {
      id: 2,
      title: "Event",
      link: "/event ",
      active: true,
    },
  ];

  useEffect(() => {
    document.title = "Event";
  }, []);

  let rendierViewData = null;
  rendierViewData = data.map((item) => (
    <div key={item.id}>
      <img
        className="rounded-t-md h-[300px] 2xl:max-h-80 2xl:h-full"
        src={item.img}
        alt="event"
      />
      {/* <div className="flex items-center gap-2 pt-6 pb-4">
        <span className="flex-shrink-0 inline-flex"> {Icons.clockIcon}</span>
        <h5 className="text-gray-900 text-base font-bold m-0 break-words">
          {item.date}
        </h5>
      </div> */}
      <h4 className="text-gray-800 lg:text-2xl md:text-xl text-lg font-bold m-0 break-words">
        {item.title}
      </h4>
      <p className="text-gray-700 leading-7 font-normal text-lg m-0 break-words py-4">
        {item.content}
      </p>
      {/* <div className="flex items-center gap-2">
        <span className="flex-shrink-0 inline-flex">
          <svg
            width="19"
            height="24"
            viewBox="0 0 19 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.5 0C4.708 0 .81 3.9.81 8.692c0 5.948 7.778 14.68 8.11 15.048a.783.783 0 0 0 1.164 0c.331-.368 8.11-9.1 8.11-15.048C18.192 3.899 14.292 0 9.5 0Zm0 13.065a4.378 4.378 0 0 1-4.373-4.373A4.378 4.378 0 0 1 9.5 4.319a4.378 4.378 0 0 1 4.373 4.373A4.378 4.378 0 0 1 9.5 13.065Z"
              fill="#595959"
            />
          </svg>
        </span>
        <h5 className="text-gray-900 text-base font-bold m-0 break-words">
          {item.location}
        </h5>
      </div> */}
      {/* <Link to={item.link} className=" mt-4 flex items-center gap-2">
        <h4 className="uppercase text-on-tertiary-container text-lg sm:text-base font-bold m-0 break-words">
          Learn More
        </h4>
        {Icons.rightArrowIcon}
      </Link> */}
    </div>
  ));

  return (
    <div className="payment">
      {/* <BreadCrumb title="Upcoming Events" breadCrumbArray={breadCrumbArray} /> */}
      <div className="py-12 sm:py-20">
        <div className="container mt-10 max-w-2xl mx-auto px-4 text-center">
          {/* <h4 className="pb-2 text-primary font-bold text-sm m-0 break-words uppercase tracking-widest">
            All Events
          </h4> */}
          <h2 className="pb-4 text-gray-900 text-xl lg:text-5xl md:text-3xl font-bold m-0 break-words">
            Upcoming Events
          </h2>
          <p className="pb-12 leading-7 font-normal text-lg text-white m-0 break-words text-gray-800">
            Here is our 2025 event plans. Feel free to join our events
          </p>
        </div>
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-14">
            {rendierViewData}
          </div>
        </div>
        {/* <Pagination /> */}
      </div>
      {/* <BecomeYoutuber /> */}
      {/* <Feature /> */}
      <LatestNews />
    </div>
  );
};

export default EventPage;
